import React from 'react'
import { useTranslation } from 'i18n'

import CopyToClipboardButton from './CopyToClipboardButton'
import OptionalDropdownButton from './OptionalDropdownButton'
import PlaceholderImage from 'components/PlaceholderImage'

import './ResultListPanel.scss'

export const ResultListPanel = ({
  title,
  detail,
  items = [],
  dropdownButtons = [],
  imageUrl,
  onLinkClick = function (id, url) {},
  shareIcons = null,
  onClipboardCopy = function () {},
}) => {
  const { t } = useTranslation('grocery')
  const itemTextOnlyArr = items.map(item => {
    return item.label.replace(/<[^>]*>/g, '')
  })
  const textToCopy = itemTextOnlyArr.join(', ')
  return (
    <div className={`grocery-result-panel`}>
      {title && (
        <h2
          className="step-content__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}

      <div className={`columns`}>
        <div className={`col`}>
          {detail && (
            <div
              className={`detail`}
              dangerouslySetInnerHTML={{ __html: detail }}
            />
          )}
          {items && (
            <ul className="items">
              {items.map((item, i) => {
                return (
                  <li
                    key={i}
                    dangerouslySetInnerHTML={{ __html: item.label }}
                  />
                )
              })}
            </ul>
          )}
          {dropdownButtons && (
            <div className="result-multibuttons">
              {dropdownButtons.map((dropdownButton, i) => {
                return (
                  <OptionalDropdownButton
                    key={i}
                    id={dropdownButton.id}
                    label={dropdownButton.buttonCopy}
                    links={dropdownButton.links}
                    onLinkClick={onLinkClick}
                  />
                )
              })}
            </div>
          )}
          <CopyToClipboardButton
            id="copy"
            label={t('copyListToClipboard')}
            textToCopy={textToCopy}
            onClick={onClipboardCopy}
          />
          {shareIcons}
        </div>
        {imageUrl && (
          <div className={`col image`}>
            <PlaceholderImage src={imageUrl} height={400} width={600} />
          </div>
        )}
      </div>
    </div>
  )
}
export default ResultListPanel
